export const getDefaultBomErrors = () => {
  return {
    missing_mpns: [],
    missing_reference_designators: [],
    mpn_duplicates: [],
    rd_duplicates: [],
  }
}

export const findBomErrors = (bom_line_items) => {
  if(!bom_line_items || bom_line_items.length == 0) return getDefaultBomErrors()

  let missing_mpns = []
  let missing_reference_designators = []
  let mpn_duplicates = []
  let rd_duplicates = []

  let mpn_map = new Map();
  let rd_map = new Map();

  bom_line_items.forEach((bli, idx) => {
    if(!bli.mpn || bli.mpn == "") missing_mpns.push({idx, bli_id: bli.id})
    if(!bli.reference_designator || bli.reference_designator == "") missing_reference_designators.push({idx, bli_id: bli.id})

    if(bli.mpn && bli.mpn != ""){
      if(!mpn_map.get(bli.mpn)) mpn_map.set(bli.mpn, [])
      let mpn_arr = mpn_map.get(bli.mpn)
      mpn_arr.push({idx, bli_id: bli.id})
    }
    
    if(bli.reference_designator && bli.reference_designator != ""){
      const reference_designators = bli.reference_designator.split(",")
      reference_designators.forEach((rd) => {
        if(!rd_map.get(rd)) rd_map.set(rd, [])
        let rd_arr = rd_map.get(rd)
        rd_arr.push({idx, bli_id: bli.id})
      })
    }
    
  })

  mpn_map.forEach((value, key) => { if(value.length > 1) mpn_duplicates.push({mpn: key, bom_line_items: value}) })
  rd_map.forEach((value, key) => { if(value.length > 1) rd_duplicates.push({rd: key, bom_line_items: value}) })

  return {
    missing_mpns,
    missing_reference_designators,
    mpn_duplicates,
    rd_duplicates,
  }
}